/* ==========================================================================
   STR PAGE — Sensibo for Short-Term Rentals
   Interactive pricing, ROI calculator, FAQ accordion, and add-to-cart
   ========================================================================== */
(function () {
  'use strict';

  /* ── Pricing Data (hardcoded) ── */
  var PRICING = [
    { rooms: 1, monthly: 33, annual: 99,  discount: 0 },
    { rooms: 2, monthly: 30, annual: 90,  discount: 10 },
    { rooms: 3, monthly: 28, annual: 84,  discount: 15 },
    { rooms: 4, monthly: 27, annual: 81,  discount: 18 },
    { rooms: 5, monthly: 26, annual: 78,  discount: 20 },
    { rooms: 6, monthly: 25, annual: 75,  discount: 22 },
    { rooms: 7, monthly: 24, annual: 72,  discount: 25 }
  ];

  var SAVINGS_RATE = 0.40;
  var AC_PORTION = 0.50;

  /* ── Shared State ── */
  var state = {
    rooms: 1,
    monthlyBill: 400,
    billing: 'annual'
  };

  /* ── DOM References ── */
  var els = {};

  function cacheDom() {
    els.slider = document.getElementById('str-bill-slider');
    els.billDisplay = document.getElementById('str-bill-display');
    els.monthlySavings = document.getElementById('str-monthly-savings');
    els.annualSavings = document.getElementById('str-annual-savings');
    els.payoff = document.getElementById('str-payoff');
    els.roomInput = document.getElementById('str-room-quantity');
    els.buyboxCards = document.querySelectorAll('.str-buybox__card');

    // (ROI is now part of calculator results, no separate elements needed)

    // Buybox summary
    els.ctaRooms = document.getElementById('str-cta-rooms');
    els.ctaTotal = document.getElementById('str-cta-total');
    els.addToCart = document.getElementById('str-add-to-cart');
  }

  /* ── Formatting ── */
  function formatMoney(amount) {
    return '$' + amount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  /* ── Slider Track Fill ── */
  function updateSliderTrack() {
    if (!els.slider) return;
    var min = parseInt(els.slider.min, 10);
    var max = parseInt(els.slider.max, 10);
    var val = parseInt(els.slider.value, 10);
    var pct = ((val - min) / (max - min)) * 100;
    els.slider.style.backgroundSize = pct + '% 100%';
  }

  /* ── Core Update ── */
  function updateAll() {
    var p = PRICING[Math.min(state.rooms, 7) - 1];
    var bill = state.monthlyBill;

    // Calculator outputs (savings on your total bill, not per room)
    var monthlySavings = Math.round(bill * SAVINGS_RATE);
    var annualSavings = monthlySavings * 12;
    var annualCost = p.annual * state.rooms;
    var monthsToPayoff = monthlySavings > 0 ? Math.ceil(annualCost / monthlySavings) : 99;

    // Sync calculator room buttons
    document.querySelectorAll('.str-calc__room-btn').forEach(function (btn) {
      var r = parseInt(btn.getAttribute('data-calc-rooms'), 10);
      if (r === state.rooms) {
        btn.classList.add('str-calc__room-btn--active');
      } else {
        btn.classList.remove('str-calc__room-btn--active');
      }
    });

    if (els.billDisplay) els.billDisplay.textContent = formatMoney(bill);
    if (els.monthlySavings) els.monthlySavings.textContent = formatMoney(monthlySavings);
    if (els.annualSavings) els.annualSavings.textContent = formatMoney(annualSavings);
    if (els.payoff) els.payoff.textContent = monthsToPayoff + (monthsToPayoff === 1 ? ' mo' : ' mos');

    // Slider track
    updateSliderTrack();

    // Buybox cards — highlight active + update prices (always show /mo)
    var isAnnual = state.billing === 'annual';
    els.buyboxCards.forEach(function (card) {
      var cardRooms = parseInt(card.getAttribute('data-rooms'), 10);
      var monthlyPrice = parseInt(card.getAttribute('data-monthly'), 10);
      var annualPrice = parseInt(card.getAttribute('data-annual'), 10);
      var monthlyEquiv = parseFloat((annualPrice / 12).toFixed(2));

      // Highlight active
      if (cardRooms === state.rooms) {
        card.classList.add('str-buybox__card--active');
      } else {
        card.classList.remove('str-buybox__card--active');
      }

      // Always show monthly price, change the "billed" line
      var priceEl = card.querySelector('.str-buybox__card-price');
      var billedEl = card.querySelector('.str-buybox__card-billed');
      if (priceEl) {
        priceEl.textContent = formatMoney(isAnnual ? monthlyEquiv : monthlyPrice);
      }
      if (billedEl) {
        if (isAnnual) {
          billedEl.textContent = 'Billed ' + formatMoney(annualPrice) + '/yr' + (cardRooms > 1 ? ' each' : '');
        } else {
          billedEl.textContent = formatMoney(monthlyEquiv) + '/mo if paid annually';
        }
      }
    });

    // (no separate ROI section to update)

    // Buybox total — show what you actually pay
    var total = isAnnual
      ? p.annual * state.rooms
      : p.monthly * state.rooms;
    var periodEl = document.getElementById('str-cta-period');
    if (els.ctaRooms) els.ctaRooms.textContent = state.rooms;
    if (els.ctaTotal) els.ctaTotal.textContent = formatMoney(total);
    if (periodEl) periodEl.textContent = isAnnual ? '/yr' : '/mo';

    // Update hidden room input
    if (els.roomInput) els.roomInput.value = state.rooms;

    // Update floating bar
    var floatingPrice = document.getElementById('str-floating-price');
    var floatingPeriod = document.getElementById('str-floating-period');
    var floatingBadge = document.getElementById('str-floating-rooms-badge');
    if (floatingPrice) floatingPrice.textContent = formatMoney(isAnnual ? parseFloat((p.annual / 12).toFixed(2)) : p.monthly);
    if (floatingPeriod) floatingPeriod.textContent = '/mo per room';
    if (floatingBadge) floatingBadge.textContent = state.rooms + (state.rooms === 1 ? ' room' : ' rooms');
  }

  /* ── Event Handlers ── */
  function onSliderChange() {
    state.monthlyBill = parseInt(els.slider.value, 10);
    updateAll();
  }

  function onRoomQtyClick(e) {
    var btn = e.target.closest('.str-qty__btn');
    if (!btn) return;

    var dir = btn.getAttribute('data-dir');
    if (dir === 'up' && state.rooms < 7) {
      state.rooms++;
    } else if (dir === 'down' && state.rooms > 1) {
      state.rooms--;
    }
    updateAll();
  }

  function onRoomInputChange() {
    var val = parseInt(els.roomInput.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (val > 7) val = 7;
    state.rooms = val;
    updateAll();
  }

  /* ── Buybox Card Click ── */
  function onBuyboxCardClick(e) {
    var card = e.target.closest('.str-buybox__card');
    if (!card) return;
    var rooms = parseInt(card.getAttribute('data-rooms'), 10);
    if (rooms >= 1 && rooms <= 7) {
      state.rooms = rooms;
      updateAll();
    }
  }

  /* ── Billing Toggle ── */
  function onBillingToggle(e) {
    var btn = e.target.closest('.str-buybox__toggle-btn');
    if (!btn) return;

    var billing = btn.getAttribute('data-billing');
    if (!billing) return;

    state.billing = billing;

    // Toggle active class
    document.querySelectorAll('.str-buybox__toggle-btn').forEach(function (b) {
      b.classList.remove('str-buybox__toggle-btn--active');
    });
    btn.classList.add('str-buybox__toggle-btn--active');

    // Update billing hint
    var hint = document.getElementById('str-billing-hint');
    if (hint) {
      if (billing === 'annual') {
        hint.textContent = "Most hosts choose annual. It's 75% less than monthly.";
        hint.classList.remove('str-buybox__billing-hint--monthly');
      } else {
        hint.textContent = 'Switch to annual and pay $8.25/mo instead of $33/mo.';
        hint.classList.add('str-buybox__billing-hint--monthly');
      }
    }

    updateAll();
  }

  /* ── FAQ Accordion ── */
  function initFaq() {
    var faqItems = document.querySelectorAll('.str-faq__item');
    faqItems.forEach(function (item) {
      var question = item.querySelector('.str-faq__question');
      if (!question) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('str-faq__item--open');

        // Close all others
        faqItems.forEach(function (other) {
          other.classList.remove('str-faq__item--open');
        });

        // Toggle current
        if (!isOpen) {
          item.classList.add('str-faq__item--open');
        }
      });
    });
  }

  /* ── Floating Add to Cart Bar ── */
  function initFloatingAtc() {
    var mainBtn = document.getElementById('str-add-to-cart');
    var floatingBar = document.getElementById('str-floating-atc');
    var floatingBtn = document.getElementById('str-floating-btn');
    if (!mainBtn || !floatingBar) return;

    // Show/hide based on main button visibility
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          floatingBar.classList.remove('str-floating-atc--visible');
        } else {
          floatingBar.classList.add('str-floating-atc--visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainBtn);

    // Click handler — trigger main button
    if (floatingBtn) {
      floatingBtn.addEventListener('click', function () {
        mainBtn.click();
      });
    }
  }

  /* ── Buybox Image Carousel ── */
  function initCarousel() {
    var carousel = document.getElementById('str-carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.str-buybox__carousel-slide');
    var thumbs = carousel.querySelectorAll('.str-buybox__carousel-thumb');
    var current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach(function (s) { s.classList.remove('str-buybox__carousel-slide--active'); });
      thumbs.forEach(function (t) { t.classList.remove('str-buybox__carousel-thumb--active'); });
      slides[index].classList.add('str-buybox__carousel-slide--active');
      if (thumbs[index]) thumbs[index].classList.add('str-buybox__carousel-thumb--active');
      current = index;
    }

    carousel.addEventListener('click', function (e) {
      var arrow = e.target.closest('.str-buybox__carousel-arrow');
      if (arrow) {
        goTo(arrow.getAttribute('data-dir') === 'next' ? current + 1 : current - 1);
        return;
      }
      var thumb = e.target.closest('.str-buybox__carousel-thumb');
      if (thumb) {
        goTo(parseInt(thumb.getAttribute('data-index'), 10));
      }
    });
  }

  /* ── Smooth Scroll for anchor links ── */
  function initSmoothScroll() {
    document.querySelectorAll('.str-page a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(link.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── Add to Cart ── */
  function addSTRToCart() {
    var btn = els.addToCart;
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    var originalText = btn.innerHTML;
    btn.innerHTML = '<span>Adding...</span>';

    /* Look up the correct variant (annual or monthly) */
    var billingKey = state.billing === 'annual' ? 'annual' : 'monthly';
    var variantData = window.STR_VARIANTS && window.STR_VARIANTS[billingKey];

    if (!variantData) {
      console.error('Variant not found for', billingKey);
      btn.innerHTML = originalText;
      btn.disabled = false;
      return;
    }

    var cartElement = document.querySelector('cart-drawer');

    /* A/B test hook: an experiment (e.g. Convert) can set window.STR_SENSOR_PROP
       to tag the order with a line item property (e.g. sensor count) so ops can
       fulfill accordingly. Inert unless the flag is set — default behavior is
       unchanged. */
    var lineItem = {
      id: variantData.id,
      quantity: state.rooms,
      selling_plan: variantData.sellingPlanId
    };
    if (window.STR_SENSOR_PROP) {
      lineItem.properties = window.STR_SENSOR_PROP;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [lineItem],
        sections: cartElement && cartElement.getSectionsToRender
          ? cartElement.getSectionsToRender().map(function (s) { return s.section || s.id; })
          : []
      })
    })
    .then(function (response) {
      if (response.ok) {
        return response.json().then(function (data) {
          btn.innerHTML = originalText;
          btn.disabled = false;
          if (cartElement && cartElement.renderContents) {
            cartElement.renderContents(data);
          } else {
            window.location.href = '/cart';
          }
        });
      } else {
        console.error('Error adding to cart');
        btn.innerHTML = originalText;
        btn.disabled = false;
      }
    })
    .catch(function () {
      console.error('Network error adding to cart');
      btn.innerHTML = originalText;
      btn.disabled = false;
    });
  }

  /* ── Calculator Room Buttons ── */
  function onCalcRoomClick(e) {
    var btn = e.target.closest('.str-calc__room-btn');
    if (!btn) return;

    var rooms = parseInt(btn.getAttribute('data-calc-rooms'), 10);
    if (rooms >= 1 && rooms <= 7) {
      state.rooms = rooms;

      // Update active state on calc buttons
      document.querySelectorAll('.str-calc__room-btn').forEach(function (b) {
        b.classList.remove('str-calc__room-btn--active');
      });
      btn.classList.add('str-calc__room-btn--active');

      updateAll();
    }
  }

  /* ── Initialize ── */
  function init() {
    cacheDom();

    // Slider
    if (els.slider) {
      els.slider.addEventListener('input', onSliderChange);
    }

    // Calculator room buttons
    var calcRooms = document.querySelector('.str-calc__rooms');
    if (calcRooms) {
      calcRooms.addEventListener('click', onCalcRoomClick);
    }

    // Buybox card click
    var buyboxCards = document.querySelector('.str-buybox__cards');
    if (buyboxCards) {
      buyboxCards.addEventListener('click', onBuyboxCardClick);
    }

    // Billing toggle
    var billingToggle = document.querySelector('.str-buybox__toggle');
    if (billingToggle) {
      billingToggle.addEventListener('click', onBillingToggle);
    }

    // Add to cart button
    if (els.addToCart) {
      els.addToCart.addEventListener('click', addSTRToCart);
    }

    // Floating ATC bar
    initFloatingAtc();

    // FAQ accordion
    initFaq();

    // Image carousel
    initCarousel();

    // Smooth scroll
    initSmoothScroll();

    // Initial render
    updateAll();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
